var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.sortedChecklists),function(checklist){return _c('div',{key:checklist.id},[_c('checklist-fillable',{attrs:{"checklist":checklist,"readonly":_vm.readonly},on:{"deleted":_vm.removeChecklist}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }